"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var AutomaticEmail_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutomaticEmail = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const statusGetter_1 = require("../statusGetter");
const AutomaticEmailBase_1 = require("./AutomaticEmailBase");
const AutomaticEmailEvent_1 = require("./AutomaticEmailEvent");
// AutomaticEmail and AutomaticEmailEvent extend the same base class that contains event time properties
// and status prototype. I did this way because status prototype rely on those properties, and both AutomaticEmail
// AutomaticEmailEvent has to have status
// In the future we might remove event times from AutomaticEmail completely, since it's having multiple events
// for separate recipients is a pretty usual thing
let AutomaticEmail = AutomaticEmail_1 = class AutomaticEmail extends AutomaticEmailBase_1.AutomaticEmailBase {
    mailgunId;
    type;
    userId;
    to;
    events = [];
    get status() {
        // If AutomaticEmail has multiple events - then it's status might be mixed
        // (when events have different statuses themselves)
        if (this.events && this.events.length > 0) {
            this.events = (0, class_transformer_1.plainToClass)(AutomaticEmailEvent_1.AutomaticEmailEvent, this.events);
            // This array will contain distinct statuses of events
            const eventsStatuses = [];
            for (const event of this.events) {
                if (eventsStatuses.includes(event.status) === false) {
                    eventsStatuses.push(event.status);
                }
            }
            // If there is more than one status - then it's mixed
            // Otherwise use AutomaticEmail prototype
            if (eventsStatuses.length > 1) {
                return legacy_enums_1.AutomaticEmailStatus.Mixed;
            }
        }
        return (0, statusGetter_1.statusGetter)(this, AutomaticEmail_1, legacy_enums_1.AutomaticEmailStatus);
    }
};
exports.AutomaticEmail = AutomaticEmail;
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AutomaticEmail.prototype, "mailgunId", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Int),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], AutomaticEmail.prototype, "type", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AutomaticEmail.prototype, "userId", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AutomaticEmail.prototype, "to", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => [AutomaticEmailEvent_1.AutomaticEmailEvent]),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Array)
], AutomaticEmail.prototype, "events", void 0);
exports.AutomaticEmail = AutomaticEmail = AutomaticEmail_1 = __decorate([
    (0, type_graphql_1.ObjectType)("AutomaticEmail"),
    (0, type_graphql_1.InputType)("AutomaticEmailInput"),
    (0, class_transformer_1.Exclude)()
], AutomaticEmail);
//# sourceMappingURL=AutomaticEmail.js.map